import { ChevronDown, ChevronUp } from 'lucide-react'
import { getBdrInitials, formatBdrDate } from '@/components/BdrPanelV2/bdrTableShared'

export { getBdrInitials, formatBdrDate }

export function getAllLeadsTemperature(score: number): { label: string; color: string } {
  if (score >= 80) return { label: 'Quente', color: '#ef4444' }
  if (score >= 50) return { label: 'Morno', color: '#f59e0b' }
  return { label: 'Frio', color: '#0ea5e9' }
}

export function getAllLeadsStatusInfo(status: string): { label: string; color: string } {
  const map: Record<string, { label: string; color: string }> = {
    novo: { label: 'Novo', color: '#3B82F6' },
    sql: { label: 'SQL', color: '#10B981' },
    lead: { label: 'Lead', color: '#F59E0B' },
    follow_up: { label: 'Follow-up', color: '#F59E0B' },
    atrasado: { label: 'Atrasado', color: '#ef4444' },
    nutricao: { label: 'Nutricao', color: '#8B5CF6' },
    handoff: { label: 'Handoff', color: '#14BDBD' },
    perdido: { label: 'Perdido', color: '#6b7280' },
  }
  return map[status] ?? { label: status, color: '#6b7280' }
}

export function AllLeadsSortIcon({
  field,
  sortField,
  sortDir,
}: {
  field: string
  sortField: string
  sortDir: string
}) {
  if (sortField !== field) return <ChevronDown size={12} className="opacity-30" />
  return sortDir === 'asc' ? (
    <ChevronUp size={12} className="text-accent" />
  ) : (
    <ChevronDown size={12} className="text-accent" />
  )
}

export interface AllLeadsSelectOption {
  value: string
  label: string
}

export function AllLeadsInlineSelect({
  value,
  onChange,
  options,
  placeholder,
}: {
  value: string
  onChange: (v: string) => void
  options: AllLeadsSelectOption[]
  placeholder: string
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white/[0.04] border border-white/[0.06] text-text-primary text-xs rounded-lg px-3 py-2 outline-none focus:border-accent transition-colors min-h-[44px] appearance-none cursor-pointer"
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  )
}

export function AllLeadsSkeletonRow() {
  return (
    <tr className="border-b border-white/[0.04]">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <td key={i} className="px-3 py-3">
          <div className="h-4 bg-white/[0.04] rounded animate-pulse" />
        </td>
      ))}
    </tr>
  )
}
